// extracted by mini-css-extract-plugin
export default {"root":"XsellButton-root_uLhpS","default":"XsellButton-default_rmGtA"};